import React, { useContext, useEffect, useState } from "react";
import classes from "./Details.module.css";
import Rating from "@mui/material/Rating";
import { toast } from "react-toastify";
import { FormControl, MenuItem, Select } from "@mui/material";
import TextField from "@mui/material/TextField";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import paypal from "../../../assets/pay-pal.png";
import visa from "../../../assets/visa.png";
import mastercard from "../../../assets/master-card.png";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { FaFacebookF, FaPinterestP } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import ViewTab from "../View Tab and review/ViewTab";
import AuthContext from "../../Common/authContext";
import { useDispatch, useSelector } from "react-redux";
import NoVariants from "../../../assets/NoVariants.png";
import {
  addTocart,
  addTocompare,
  addTofavorite,
  deletefavorite,
  addSearchData,
  resetSearchData,
  updateSelectedVariantProduct,
  resetSelectedVariantProduct,
  updateSelectedVariants,
  resetSelectedVariants,
} from "../../redux/productSlice";
import { useNavigate } from "react-router-dom";
import HtmlFields from "../../Common/HtmlFields";
import axios from "axios";

const Details = () => {
  const language = useSelector(
    (state) => state.products.selectedLanguage[0].Language
  );
  const authCtx = useContext(AuthContext);
  const currency = useSelector(
    (state) => state.products.selectedCurrency[0].currency
  );
  const navigate = useNavigate();
  const user = useSelector((state) => state.products.userInfo);
  const dispatch = useDispatch();
  const options = ["Option 1", "Option 2", "Option 3", "Option 4"];
  const [selectedOption, setSelectedOption] = useState("CATÉGORIES");
  const [searchQuery, setSearchQuery] = useState("");
  const [favorite, setfavorite] = useState(true);
  const [averageRating, setaverageRating] = useState(0);
  const favoriteData = useSelector((state) => state.products.favorites);
  const selectedBook = useSelector((state) => state.products.selectedBook[0]);
  const [categoryItem, setCategoryItem] = useState(null);

  const [count, setCount] = React.useState(1);

  const handleCountChange = (event) => {
    const value = Number(event.target.value);  // Convert value to number
  
    if (value < 1) {
      setCount(1);  // Set count to 1 if the value is less than 1
    } else if (value < Number(selectedBook?._qte_a_terme_calcule)) {
      setCount(value);  // Set count to the value if it's within the allowed range
    } else {
      setCount(Number(selectedBook?._qte_a_terme_calcule).toFixed(0));  // Set count to the max allowed value
    }
  };

  useEffect(() => {
    const calculateAverageRating = () => {
      if (
        !selectedBook?.bookreview ||
        !Array.isArray(selectedBook?.bookreview) ||
        selectedBook?.bookreview?.length === 0
      ) {
        return 0; // Return 0 if there are no reviews or if bookreview is not an array
      }

      const validRatings = selectedBook?.bookreview?.filter(
        (review) => !isNaN(parseFloat(review.rate))
      );

      if (validRatings?.length === 0) {
        return 0; // Return 0 if there are no valid ratings
      }

      const totalRatings = selectedBook?.bookreview?.reduce(
        (accumulator, review) => accumulator + parseFloat(review.rate),
        0
      );
      let reviewsCount = selectedBook?.bookreview?.length;

      return totalRatings / reviewsCount;
    };

    const averageRate = calculateAverageRating();
    setaverageRating(averageRate);
  }, [selectedBook]);

  useEffect(() => {
    {
      favoriteData.some((book) => book._favid === selectedBook?.id)
        ? setfavorite(true)
        : setfavorite(false);
    }
  }, [selectedBook]);

  const FavoriteClick = () => {
    if (user?.id) {
      if (favorite) {
        authCtx.deleteFavorite(selectedBook?.id);
      } else {
        authCtx.addToFavorite(selectedBook);
      }
      setfavorite(!favorite);
    } else {
      toast.error(`${language === 'eng' ? "Please login to add to wishlist." : "Veuillez vous connecter pour ajouter à votre liste de souhaits."}`, {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
    }
  };
  const numberOptions = Array.from({ length: 50 }, (_, index) => index + 1);

  const getToken = () => {
    return sessionStorage.getItem('token');
  };

  const token = getToken();
  
  const handleSuivreCollab = async () => {
    if (!user) {
        // If user is not defined, throw an error
        toast.error(`${language === 'eng' ? "Please log in first" : "Veuillez d'abord vous connecter"}`);
        return;
    }

    try {
        // Fetch the list of collaborators
        const collaboratorsResponse = await axios.get(`${process.env.REACT_APP_TESTING_API}/collaborators?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`);
        const collaborators = collaboratorsResponse.data;

        const cleanedAuteur = selectedBook?.dc_auteur.trim();
        // Find the collaborator whose nom + prenom matches selectedBook?.dc_auteur
        const collaborator = collaborators.find(collaborator => {
            const fullName = `${collaborator.nom}`;
            console.log(fullName.toLowerCase())
            console.log(cleanedAuteur.toLowerCase())
            return fullName.toLowerCase() === cleanedAuteur.toLowerCase();
        });
        
        if (!collaborator) {
            throw new Error('Collaborator not found');
        }

        // Send the subscription request with the found collaborator's id
        const response = await axios.post(`${process.env.REACT_APP_TESTING_API}/users/${user.id}/subscriptions`, {
            collaborator_id: collaborator.id,
            ecom_type: `${process.env.REACT_APP_ECOM_TYPE}`
        }, {
            headers: {
                Authorization: `Bearer ${token}` // Include token in the headers
            }
        });

        // console.log(response.data);
        toast.success(`${collaborator.nom} subscribed successfully!`, {hideProgressBar: true}); // You can handle the response here
    } catch (error) {
        // console.error('Error:', error);
        toast.error(error.response?.data?.error || error.message);
    }
};

const handleSuivreEditor = async () => {
  if (!user) {
      // If user is not defined, throw an error
      toast.error(`${language === 'eng' ? "Please log in first" : "Veuillez d'abord vous connecter"}`);
      return;
  }

  try {
      // Fetch the list of collaborators
      const collaboratorsResponse = await axios.get(`${process.env.REACT_APP_TESTING_API}/collaborators?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`);
      const collaborators = collaboratorsResponse.data;

      const cleanedAuteur = selectedBook?.dc_editor.trim();
      // Find the collaborator whose nom + prenom matches selectedBook?.dc_auteur
      const collaborator = collaborators.find(collaborator => {
          const fullName = `${collaborator.nom}`;
          // console.log(fullName.toLowerCase())
          // console.log(cleanedAuteur.toLowerCase())
          return fullName.toLowerCase() === cleanedAuteur.toLowerCase();
      });

      if (!collaborator) {
          throw new Error('Collaborator not found');
      }

      // Send the subscription request with the found collaborator's id
      const response = await axios.post(`${process.env.REACT_APP_TESTING_API}/users/${user.id}/subscriptions`, {
          collaborator_id: collaborator.id,
          ecom_type: `${process.env.REACT_APP_ECOM_TYPE}`
      }, {
          headers: {
              Authorization: `Bearer ${token}` // Include token in the headers
          }
      });

      // console.log(response.data);
      toast.success(`${language === 'eng' ? `${collaborator.nom} subscribed successfully!` : `${collaborator.nom} abonné avec succès !!`}`, {hideProgressBar: true}); // You can handle the response here
  } catch (error) {
      // console.error('Error:', error);
      toast.error(error.response?.data?.error || error.message);
  }
};

const handleSuivreTranslator = async () => {
  if (!user) {
      // If user is not defined, throw an error
      toast.error(`${language === 'eng' ? "Please log in first" : "Veuillez d'abord vous connecter"}`);
      return;
  }

  try {
      // Fetch the list of collaborators
      const collaboratorsResponse = await axios.get(`${process.env.REACT_APP_TESTING_API}/collaborators?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`);
      const collaborators = collaboratorsResponse.data;

      const cleanedAuteur = selectedBook?.dc_traducteur.trim();
      // Find the collaborator whose nom + prenom matches selectedBook?.dc_auteur
      const collaborator = collaborators.find(collaborator => {
          const fullName = `${collaborator.nom}`;
          // console.log(fullName.toLowerCase())
          // console.log(cleanedAuteur.toLowerCase())
          return fullName.toLowerCase() === cleanedAuteur.toLowerCase();
      });

      if (!collaborator) {
          throw new Error('Collaborator not found');
      }

      // Send the subscription request with the found collaborator's id
      const response = await axios.post(`${process.env.REACT_APP_TESTING_API}/users/${user.id}/subscriptions`, {
          collaborator_id: collaborator.id,
          ecom_type: `${process.env.REACT_APP_ECOM_TYPE}`
      }, {
          headers: {
              Authorization: `Bearer ${token}` // Include token in the headers
          }
      });

      // console.log(response.data);
      toast.success(`${language === 'eng' ? `${collaborator.nom} subscribed successfully!` : `${collaborator.nom} abonné avec succès !!`}`, {hideProgressBar: true}); // You can handle the response here
  } catch (error) {
      // console.error('Error:', error);
      toast.error(error.response?.data?.error || error.message);
  }
};
const handleSuivreIllustrateur = async () => {
  if (!user) {
      // If user is not defined, throw an error
      toast.error(`${language === 'eng' ? "Please log in first" : "Veuillez d'abord vous connecter"}`);
      return;
  }

  try {
      // Fetch the list of collaborators
      const collaboratorsResponse = await axios.get(`${process.env.REACT_APP_TESTING_API}/collaborators?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`);
      const collaborators = collaboratorsResponse.data;

      const cleanedAuteur = selectedBook?.dc_illustrateur.trim();
      // Find the collaborator whose nom + prenom matches selectedBook?.dc_auteur
      const collaborator = collaborators.find(collaborator => {
          const fullName = `${collaborator.nom}`;
          // console.log(fullName.toLowerCase())
          // console.log(cleanedAuteur.toLowerCase())
          return fullName.toLowerCase() === cleanedAuteur.toLowerCase();
      });

      if (!collaborator) {
          throw new Error('Collaborator not found');
      }

      // Send the subscription request with the found collaborator's id
      const response = await axios.post(`${process.env.REACT_APP_TESTING_API}/users/${user.id}/subscriptions`, {
          collaborator_id: collaborator.id,
          ecom_type: `${process.env.REACT_APP_ECOM_TYPE}`
      }, {
          headers: {
              Authorization: `Bearer ${token}` // Include token in the headers
          }
      });

      // console.log(response.data);
      toast.success(`${language === 'eng' ? `${collaborator.nom} subscribed successfully!` : `${collaborator.nom} abonné avec succès !!`}`, {hideProgressBar: true}); // You can handle the response here
  } catch (error) {
      // console.error('Error:', error);
      toast.error(error.response?.data?.error || error.message);
  }
};


const handleSuivreCollection = async () => {
  if (!user) {
      // If user is not defined, throw an error
      toast.error(`${language === 'eng' ? "Please log in first" : "Veuillez d'abord vous connecter"}`);
      return;
  }

  try {
      // Fetch the list of collaborators
      const collectionsResponse = await axios.get(`${process.env.REACT_APP_TESTING_API}/collections?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`);
      const collections = collectionsResponse.data;
      const cleanedCollec = selectedBook?.dc_collection.trim();
      // Find the collaborator whose nom + prenom matches selectedBook?.dc_auteur
      const Collectiondata = collections.find(collaborator => {
          const fullName = `${collaborator.nom}`;
          // console.log(fullName.toLowerCase())
          // console.log(cleanedCollec.toLowerCase())
          return fullName.toLowerCase() === cleanedCollec.toLowerCase();
      });

      if (!Collectiondata) {
          throw new Error('Collection not found');
      }

      // Send the subscription request with the found collaborator's id
      const response = await axios.post(`${process.env.REACT_APP_TESTING_API}/users/${user.id}/subscriptions`, {
          collection_id: Collectiondata.id,
          ecom_type: `${process.env.REACT_APP_ECOM_TYPE}`
      }, {
          headers: {
              Authorization: `Bearer ${token}` // Include token in the headers
          }
      });

      // console.log(response.data);
      toast.success(`${language === 'eng' ? `${Collectiondata.nom} subscribed successfully!` : `${Collectiondata.nom} abonné avec succès !!`}`, {hideProgressBar: true}); // You can handle the response here
  } catch (error) {
      console.error('Error:', error);
      toast.error(error.response?.data?.error || error.message);
  }
};

useEffect(() => {
  const foundItem = authCtx.categories.find(category => category.id === selectedBook?.b_usr_articletheme_id);
  setCategoryItem(foundItem);
}, [selectedBook?.b_usr_articletheme_id, authCtx.categories]);

const handleSuivreCategory = async () => {
  if (!user) {
    // If user is not defined, throw an error
    toast.error(`${language === 'eng' ? "Please log in first" : "Veuillez d'abord vous connecter"}`, {hideProgressBar: true});
    return;
}
  try {
    const response = await axios.post(`${process.env.REACT_APP_TESTING_API}/users/${user.id}/subscriptions`, {
      category_id: categoryItem?.id,
      ecom_type: `${process.env.REACT_APP_ECOM_TYPE}`
    }, {
      headers: {
          Authorization: `Bearer ${token}` // Include token in the headers
      }
  });
    // console.log(response.data);
    toast.success(`${language === 'eng' ? `${categoryItem?._nom} subscribed successfully!` : `${categoryItem._nom} abonné avec succès !!`}`, {hideProgressBar: true}) // You can handle the response here
  } catch (error) {
    // console.error('Error:', error);
    toast.error(error.response?.data?.error, {hideProgressBar: true})
  }
};

const handleCatClick = async () => {
  // Retrieve the existing categories from localStorage (or initialize an empty array)
  let storedCategories = JSON.parse(localStorage.getItem("categories")) || [];

  if (storedCategories.includes(categoryItem?.id)) {
    // If the clicked category is already selected, remove it
    return navigate(`/products`);
  } else {
    // Otherwise, add the new category
    storedCategories.push(categoryItem?.id);
  }

  // Update localStorage
  localStorage.setItem("categories", JSON.stringify(storedCategories));

  // Dispatch action to update search data with the updated category list
  dispatch(addSearchData({ category: storedCategories }));

  navigate(`/products`);
};
const handleFilterCollaborator = (collaboratorName) => {
  const cleanString = (str) => str?.toLowerCase().replace(/[^a-z0-9]/gi, '');
  const collaboratorId = authCtx.collaborators.find(
    collab => cleanString(collab.nom) === cleanString(collaboratorName)
  )?.id;
  localStorage.removeItem("category");
  localStorage.removeItem("publishers");
  localStorage.removeItem("collections");
  dispatch(resetSearchData());
  dispatch(addSearchData({ collaborators: collaboratorId }));
  navigate(`/products`);
};


const [selectedVariants, setSelectedVariants] = useState({});
  const [article_variant_combination, setSelectedCombinationVariants] = useState({});
  const [selectedVariantProductValues, setSelectedVariantProductValues] = useState({});

  const hasVariantProduct =
    (selectedBook?.variant_product?.variant_product_combine_fields?.length || 0) > 0 &&
    (selectedBook?.variant_product?.variants?.length || 0) > 0;

  const variantProductFields = selectedBook?.variant_product?.variant_product_combine_fields || [];
  const variantProductRows = selectedBook?.variant_product?.variants || [];

  const getVariantProductQty = (variantRow) => Number(variantRow?.quantity || 0);

  const variantProductMatchesSelections = (variantRow, selections) => {
    return variantProductFields.every((field) => {
      const selectedItemId = selections[field.id]?.id;
      return variantRow.values?.some((v) => v.item_id === selectedItemId);
    });
  };

  const getCompatibleVariantProducts = (selections) => {
    return variantProductRows.filter((variantRow) =>
      variantProductMatchesSelections(variantRow, selections)
    );
  };

  const selectedCompatibleVariantProducts = getCompatibleVariantProducts(selectedVariantProductValues);

  const allVariantProductFieldsSelected =
    hasVariantProduct &&
    variantProductFields.every((field) => selectedVariantProductValues[field.id]);

  const selectedVariantProductRow = allVariantProductFieldsSelected
    ? selectedCompatibleVariantProducts.find((variantRow) => getVariantProductQty(variantRow) > 0) ||
      selectedCompatibleVariantProducts[0]
    : null;

  const selectedVariantProductQty = getVariantProductQty(selectedVariantProductRow);

  const resolvedAvailableQty = hasVariantProduct
    ? (allVariantProductFieldsSelected ? selectedVariantProductQty : 0)
    : Number(article_variant_combination?.quantity || selectedBook?._qte_a_terme_calcule || 0);

  useEffect(() => {
    setSelectedVariants({});
    setSelectedVariantProductValues({});
    setSelectedCombinationVariants({});
    setCount(1);
    dispatch(resetSelectedVariants());
    dispatch(resetSelectedVariantProduct());
  }, [selectedBook?.id, dispatch]);

  useEffect(() => {
    dispatch(updateSelectedVariantProduct(selectedVariantProductRow?.product || null));
  }, [dispatch, selectedVariantProductRow]);

  useEffect(() => {
    let finalPrice = (selectedBook?.price * 1); // Start with the base price
  
    // Check if all mandatory variants are selected
    const mandatoryVariants = selectedBook?.article_variants?.filter(v => v.is_mandatory);
    const allMandatorySelected = mandatoryVariants?.every(variant => selectedVariants[variant.id]);
  
    if (allMandatorySelected) {
      // If all mandatory variants are selected, look for the matching combination
      const selectedVariantItemIds = Object.values(selectedVariants)?.map(item => item.id);
      const matchingCombination = selectedBook?.article_variant_combinations.find(comb =>
        comb.combination_variant_items?.every(item =>
          selectedVariantItemIds.includes(item.b_usr_article_variant_item_id)
        )
      );
  
      if (matchingCombination) {
        // If a matching combination is found, add its price to the final price
        setSelectedCombinationVariants(matchingCombination)
        finalPrice += parseFloat(matchingCombination.price);
      }
    }
  
    // Iterate over each selected variant
    Object.keys(selectedVariants).forEach((variantId) => {
      const variant = selectedBook?.article_variants.find(v => v.id === parseInt(variantId));
      const selectedItem = selectedVariants[variantId];
      console.log('testt', selectedItem);
  
      if (!variant.is_mandatory) {
        if (variant.price_type === "change_price") {
          finalPrice = parseFloat(selectedItem.price);  // Replace the base price
        } else if (variant.price_type === "additional") {
          finalPrice += parseFloat(selectedItem.price);  // Add to the base price
        }
      }
    });
  
    // Update the price state with the calculated final price
    // setPrice(finalPrice);
  }, [selectedVariants, selectedBook]);
  
  const handleVariantSelect = (variantId, item) => {
    setSelectedVariants(prevState => {
      const updatedState = { ...prevState };
      setCount(1)
      // If the same variant item is selected, deselect it
      if (updatedState[variantId] && updatedState[variantId].id === item.id) {
        delete updatedState[variantId];
      } else {
        // Only proceed with selecting the item if its quantity is > 0
        const itemQuantity = item?.quantity || 0;
        const newVariant = selectedBook?.article_variants?.find(pv => pv.id === parseInt(variantId));
        const isNewVariantMandatory = newVariant?.is_mandatory;
  
        // Prevent selecting non-mandatory variants with quantity <= 0
        if (!isNewVariantMandatory && itemQuantity <= 0) {
          // If it's a non-mandatory variant with no stock, just return the updated state without selecting it
          return updatedState;
        }
  
        // Proceed with selecting the variant if it's either mandatory or has stock for non-mandatory
        updatedState[variantId] = item;
  
        // Apply combination validation for mandatory variants
        if (isNewVariantMandatory) {
          Object.keys(updatedState).forEach(prevVariantId => {
            // Skip checking the currently selected variant itself
            if (parseInt(prevVariantId) === parseInt(variantId)) return;
  
            const prevSelectedVariant = updatedState[prevVariantId];
  
            // Check if the previous variant is mandatory
            const parentVariant = selectedBook?.article_variants?.find(pv => pv.id === parseInt(prevVariantId));
            const isMandatory = parentVariant?.is_mandatory;
  
            if (isMandatory) {
              const matchingCombinations = selectedBook?.article_variant_combinations?.filter(comb =>
                comb.combination_variant_items.some(combItem => combItem.b_usr_article_variant_item_id === item.id)
              );
  
              // Find a matching combination with the newly selected variant
              const matchingCombination = matchingCombinations.find(comb => {
                return comb.combination_variant_items.some(
                  combItem =>
                    combItem.b_usr_article_variant_item_id === prevSelectedVariant.id &&
                    comb.combination_variant_items.some(
                      newCombItem => newCombItem.b_usr_article_variant_item_id === item.id
                    )
                );
              });
  
              // If no valid combination or quantity is less than 1, deselect the previous mandatory variant
              if (!matchingCombination || matchingCombination.quantity < 1) {
                delete updatedState[prevVariantId];
              }
            }
          });
        }
      }

      dispatch(updateSelectedVariants(updatedState));
      return updatedState;
    });
  };

  const handleVariantProductSelect = (fieldId, item) => {
    setCount(1);
    setSelectedVariantProductValues((prevState) => {
      const updatedState = { ...prevState };

      if (updatedState[fieldId] && updatedState[fieldId].id === item.id) {
        delete updatedState[fieldId];
        return updatedState;
      }

      updatedState[fieldId] = item;

      const compatible = getCompatibleVariantProducts(updatedState);
      const hasStock = compatible.some((row) => getVariantProductQty(row) > 0);

      if (!hasStock) {
        return { [fieldId]: item };
      }

      return updatedState;
    });
  };

  

  const AddtoBag = (props) => {
    const allMandatorySelected = selectedBook?.article_variants?.every((variant) => {
      if (variant.is_mandatory) {
        return selectedVariants[variant.id] !== undefined && selectedVariants[variant.id]?.id !== undefined;
      }
      return true;
    });
  
    if (!allMandatorySelected) {
      toast.error(`Please select all mandatory variants before submitting.`, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
      return;
    }

    if (hasVariantProduct && !allVariantProductFieldsSelected) {
      toast.error(language === 'eng' ? "Please select all options." : "Veuillez sélectionner toutes les options.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
      return;
    }

    if (hasVariantProduct && resolvedAvailableQty < 1) {
      toast.error(language === 'eng' ? "Selected options are out of stock." : "Les options sélectionnées sont en rupture de stock.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
      return;
    }

    if (Number(count) > Number(resolvedAvailableQty)) {
      toast.error(language === 'eng' ? "Requested quantity exceeds stock." : "La quantité demandée dépasse le stock.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
      return;
    }

    const variantProduct = selectedVariantProductRow?.product;

    const cart_items_variants = Object.entries(selectedVariants).map(([variantId, variantItem]) => {
      const variant = selectedBook?.article_variants?.find((v) => String(v.id) === String(variantId));
      return {
        articlevariant: { nom: variant?.nom || variantId },
        variantitem: { value: variantItem?.value },
      };
    });

    const data = {
      ...props,
      ...(variantProduct ? {
        id: variantProduct.id,
        designation: variantProduct.designation || props.designation,
        _prix_public_ttc: variantProduct._prix_public_ttc ?? props._prix_public_ttc,
        _qte_a_terme_calcule: variantProduct._qte_a_terme_calcule,
        articleimage: variantProduct.articleimage?.length > 0 ? variantProduct.articleimage : props.articleimage,
        _code_barre: variantProduct._code_barre || props._code_barre,
      } : {}),
      items_quantity: Math.min(Number(count), Number(resolvedAvailableQty)),
      selectedvariants: selectedVariants,
      selected_variant_product_values: selectedVariantProductValues,
      selected_variant_product: variantProduct,
      parent_product: hasVariantProduct ? props : undefined,
      article_variant_combination: article_variant_combination,
      cart_items_variants,
    };
    authCtx.addToCart(data);
  };
  return (
    <>
      <div className={classes.contantContainer}>
        <h1 className={classes.header} onClick={() => console.log(count)}>
          {selectedBook?.name}
        </h1>
        <div className={classes.contentss}>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p
              style={{
                fontWeight: "700",
                fontSize: "calc(1.2rem + .3vw)",
                paddingBottom: "0",
                width: "90%",
              }}
            >
              {selectedBook?.designation}
            </p>

            <div className={classes.rating}>
              <span>
              <Rating
                size="small"
                name="book-rate"
                readOnly
                value={averageRating}
                precision={0.5}
                //   value={selectedBook?.rate}
                style={{
                  color: "#E0C389",
                  width: "fit-content",
                  marginLeft: "auto",
                  textAlign: "left",
                  marginTop: "0.5em",
                }}
              />

              </span>
              <p style={{ color: "var(--primary-color)", margin: "0.3em 0em 0 0.5em", fontSize: "calc(.7rem + .2vw)", textDecoration:"underline"}}>
                {selectedBook?.bookreview?.length} {language === 'eng' ? "comments" : "commentaires"}
              </p>
            </div>
          </div>
          {/* </div> */}
          <p style={{ fontWeight: "700", marginTop: "1em" }}>
            {language === "eng" ? "Description " : "Résumé"}
          </p>
          <p
            style={{ fontSize: "medium", marginBottom: "5%" }}
            dangerouslySetInnerHTML={{
              __html:
                selectedBook?.descriptif?.length > 400
                  ? selectedBook?.descriptif?.substring(0, 400) + "..."
                  : selectedBook?.descriptif,
            }}
          />
          
            {selectedBook?.article_variants?.map((variant) => {
  return (
    <div key={variant.id}>
      <p
        style={{
          fontWeight: '600',
          fontSize: 'calc(.8rem + .3vw)',
          marginBottom: '0.5em',color:"var(--accent-color)"
        }}
        onClick={() => console.log(selectedVariants)}
      >
        <span style={{color:"var(--secondary-color)"}}>{variant?.nom}</span> {' '}
        <span style={{ fontWeight: "400" }}>
          {/* {selectedVariants[variant.id]?.value} */}
          <span style={{color:"red"}}>{variant?.is_mandatory && "*"}</span>
        </span>
      </p>
      <div className={classes.selectVariant}>
        {variant.variant_items?.map((item) => {
  // Find all combinations that contain the current variant item
  const matchingCombinations = selectedBook?.article_variant_combinations?.filter(comb =>
    comb.combination_variant_items.some(combItem => combItem.b_usr_article_variant_item_id === item.id)
  );

  // Initialize availableQuantity
  let availableQuantity = 0;
  if (!variant.is_mandatory) {
    // If the variant is not mandatory, take the item's own quantity
    availableQuantity = item.quantity > 0 ? item.quantity : 0;
  } else{

  // Check if any items from other variant_ids are selected
  
  const selectedMandatoryVariants = Object.keys(selectedVariants)
  ?.map(key => ({ key, variant: selectedVariants[key] }))  // Map the objects by key
  ?.filter(({ variant }) => {
    const parentVariant = selectedBook?.article_variants?.find(pv => pv.id === variant.b_usr_article_variant_id);
    return parentVariant && parentVariant.is_mandatory;
  })
  .reduce((acc, { key, variant }) => {
    acc[key] = variant;  // Add the filtered variants back into an object using the original key
    return acc;
  }, {});

  const selectedOtherVariants = Object.keys(selectedMandatoryVariants)?.filter(variantId => 
    parseInt(variantId) !== variant.id
  );

  if (selectedOtherVariants.length === 0) {
    // No other variants are selected, sum all matching combinations' quantities
    availableQuantity = matchingCombinations.reduce((totalQty, comb) => {
      return totalQty + (comb.quantity > 0 ? comb.quantity : 0);
    }, 0);
  } else {
    // Some other variant items are selected, so filter combinations that match those
    matchingCombinations.forEach(comb => {
      // Check if all selected other variants match the combination items
      const isValidCombination = selectedOtherVariants?.every(variantId => {
        const selectedVariantItem = selectedVariants[variantId];

        // Find the corresponding combination item for the selected other variant
        const combItem = comb.combination_variant_items.find(item => item.variant_item.b_usr_article_variant_id == variantId);

        // Check if the combination item exists and matches the selected variant item
        return combItem && selectedVariantItem.id === combItem.b_usr_article_variant_item_id;
      });

      // If it's a valid combination and has quantity, add it to availableQuantity
      if (isValidCombination && comb.quantity > 0) {
        availableQuantity += comb.quantity;
      }
    });
  }
}
  // Determine if this item should be disabled based on available quantity
  const isVariantDisabled = availableQuantity <= 0;


          return (
            <div
              key={item.id}
              className={classes.variant_item}
              style={{
                padding: item?.image ? '0' : '1.7em 1em',
                border: selectedVariants[variant.id]?.id === item.id
                  ? "2px solid var(--secondary-color)"
                  : "2px solid #D9D9D9",
                opacity: isVariantDisabled ? 0.6 : 1,
              }}
              onClick={(e) => {
                e.preventDefault();
                handleVariantSelect(variant.id, item);
              }}
            >
              {item?.image ? (
                <img
                  src={item.image}
                  alt=""
                  style={{
                    width: '4.5em',
                    height: '4.5em',
                    margin: '0',
                    padding: "0",
                    display: 'block'
                  }}
                />
              ) : (
                <p style={{ fontSize:'calc(.6rem + .3vw)', margin: '0' }}>
                  {item.value} 
                  {/* <span style={{color:"red"}}>{variant?.is_mandatory && "”"}</span>  */}
                </p>
              )}
              {isVariantDisabled && (
                <div className={classes.diagonaloverlay}>
                  <img src={NoVariants} alt="" style={{width:"100%",height:"100%"}}/>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
})}

          {selectedBook?.variant_product?.variant_product_combine_fields?.map((variant) => {
            return (
              <div key={variant.id}>
                <p
                  style={{
                    fontWeight: "600",
                    fontSize: "calc(.8rem + .3vw)",
                    marginBottom: "0.5em",
                    color: "var(--accent-color)",
                  }}
                >
                  <span style={{ color: "var(--secondary-color)" }}>{variant?.field_name}</span>{" "}
                  <span style={{ color: "red" }}>*</span>
                </p>

                <div className={classes.selectVariant}>
                  {variant.values?.map((item) => {
                    const nextSelections = {
                      ...selectedVariantProductValues,
                      [variant.id]: item,
                    };

                    const compatibleRowsForItem = getCompatibleVariantProducts(nextSelections);
                    const availableQuantity = compatibleRowsForItem.reduce(
                      (sum, variantRow) => sum + Math.max(0, getVariantProductQty(variantRow)),
                      0
                    );
                    const isVariantDisabled = availableQuantity <= 0;

                    return (
                      <div
                        key={item.id}
                        className={classes.variant_item}
                        style={{
                          position: "relative",
                          padding: item?.image ? "0" : "1em 0.8em",
                          minWidth: "2.5em",
                          textAlign: "center",
                          cursor: isVariantDisabled ? "not-allowed" : "pointer",
                          border:
                            selectedVariantProductValues[variant.id]?.id === item.id
                              ? "2px solid var(--secondary-color)"
                              : "2px solid #D9D9D9",
                          opacity: isVariantDisabled ? 0.6 : 1,
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          handleVariantProductSelect(variant.id, item);
                        }}
                      >
                        {item?.image ? (
                          <img
                            src={item.image}
                            alt=""
                            style={{
                              width: "4.5em",
                              height: "4.5em",
                              margin: "0",
                              padding: "0",
                              display: "block",
                            }}
                          />
                        ) : (
                          <p style={{ fontSize: "calc(.6rem + .3vw)", margin: "0" }}>
                            {item.display_text || item.value || item.nom || item.nom_fr}
                          </p>
                        )}
                        {isVariantDisabled && (
                          <div className={classes.diagonaloverlay}>
                            <img src={NoVariants} alt="" style={{ width: "100%", height: "100%" }} />
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
        <div
          className={classes.inputdesktop}
        >
          <div style={{ display: "flex", flexDirection: "row", columnGap: "1em" }}>
            <p>
              {" "}
              <span
                style={{
                  color: "var(--accent-color)",
                  fontSize: "calc(1.4rem + 0.4vw)",
                  lineHeight: "100%",
                  paddingRight: "0.5em",
                  fontWeight: "700",
                  display: "flex",
                  flexDirection: "row",
                  width: "3.8em",
                }}
              >
                            {currency === "eur"
                              ? `${
                                selectedBook?.discount > 0
                                    ? (
                                      selectedBook?._prix_public_ttc -
                                      selectedBook?._prix_public_ttc *
                                          (selectedBook?.discount / 100)
                                      ).toFixed(2)
                                    : Number(selectedBook?._prix_public_ttc).toFixed(2)
                                }€`
                              : `${
                                selectedBook?.discount > 0
                                    ? (
                                        (selectedBook?._prix_public_ttc -
                                          selectedBook?._prix_public_ttc *
                                            (selectedBook?.discount / 100)) *
                                        authCtx.currencyRate
                                      ).toFixed(2)
                                    : (
                                      selectedBook?._prix_public_ttc * authCtx.currencyRate
                                      ).toFixed(2)
                                }$`}{" "}

              </span>{" "}
            </p>
            {selectedBook?.discount > 0 && (
              <p
                style={{
                  color: "var(--primary-color)",
                  textDecoration: "line-through",
                  fontSize: "large",
                }}
              >
                              {currency === "eur"
                                ? `€ ${Number(selectedBook?._prix_public_ttc).toFixed(2)} `
                                : `$ ${(
                                  selectedBook?._prix_public_ttc * authCtx.currencyRate
                                  ).toFixed(2)} `}
              </p>
            )}
          {selectedBook?.discount > 0 && (
            <div className={classes.discountBtn}>-{selectedBook?.discount}%</div>
          )}
          <p style={{ margin: "auto 0",color:(article_variant_combination?.quantity || selectedBook?._qte_a_terme_calcule) > 0 ? "#2DB224" : "#EE5858",fontWeight:"600" }}>{(article_variant_combination?.quantity || selectedBook?._qte_a_terme_calcule) > 0 ? `${language === "eng" ? "IN STOCK" : "EN STOCK"}` : `${language === "eng" ? "OUT OF STOCK" : "EN RUPTURE"}`} </p>
          </div>

          <div className={classes.bottonsContainer}>
            <TextField
              type="number"
              value={count}
              disabled= {selectedBook?._qte_a_terme_calcule < 1}
              onChange={handleCountChange}
              InputProps={{
                inputProps: { min: 2 },
                style: {
                  margin: "0",
                  height: "2.5em",
                  backgroundColor: "#fff",
                },
              }}
              className={classes.inputt}
            />
            <div style={{display:'flex', flexDirection:'row', justifySelf:'flex-end', columnGap:'1em'}}>
            {selectedBook?._qte_a_terme_calcule > 0 ? <button
              onClick={(event) => {
                event.stopPropagation();
                AddtoBag(selectedBook)
              }}
              style={{ fontWeight: "400",cursor:selectedBook?._qte_a_terme_calcule > 0 ? authCtx.isLoading ? "wait" : 'pointer' : "not-allowed" }}
              className={classes.button}
              disabled={(article_variant_combination?.quantity || selectedBook?._qte_a_terme_calcule) < 1 || authCtx.isLoading}
            >
              <ShoppingCartOutlinedIcon style={{ height: "0.7em" }} />
              {language === "eng" ? "Add to Cart" : " Ajouter au panier"}
            </button> : <div/>}
            
            <div className={classes.favoriteBtn} onClick={FavoriteClick}>
              {favorite ? (
                <FavoriteIcon
                  style={{
                    color: "var(--primary-color)",
                    height: "0.7em",
                    marginTop: "0.15em",
                  }}
                />
              ) : (
                <FavoriteBorderIcon
                  style={{
                    color: "var(--primary-color)",
                    height: "0.7em",
                    marginTop: "0.15em",
                  }}
                />
              )}
            </div>
            </div>
          </div>
        </div>
        <div className={classes.Inputmobile}>
          
            {selectedBook?.article_variants?.map((variant) => {
  return (
    <div key={variant.id}>
      <p
        style={{
          fontWeight: '600',
          fontSize: 'calc(.8rem + .3vw)',
          marginBottom: '0.5em',color:"var(--accent-color)"
        }}
        onClick={() => console.log(selectedVariants)}
      >
        <span style={{color:"var(--secondary-color)"}}>{variant?.nom}</span> {' '}
        <span style={{ fontWeight: "400" }}>
          {/* {selectedVariants[variant.id]?.value} */}
          <span style={{color:"red"}}>{variant?.is_mandatory && "*"}</span>
        </span>
      </p>
      <div className={classes.selectVariant}>
        {variant.variant_items?.map((item) => {
  // Find all combinations that contain the current variant item
  const matchingCombinations = selectedBook?.article_variant_combinations?.filter(comb =>
    comb.combination_variant_items.some(combItem => combItem.b_usr_article_variant_item_id === item.id)
  );

  // Initialize availableQuantity
  let availableQuantity = 0;
  if (!variant.is_mandatory) {
    // If the variant is not mandatory, take the item's own quantity
    availableQuantity = item.quantity > 0 ? item.quantity : 0;
  } else{

  // Check if any items from other variant_ids are selected
  
  const selectedMandatoryVariants = Object.keys(selectedVariants)
  ?.map(key => ({ key, variant: selectedVariants[key] }))  // Map the objects by key
  ?.filter(({ variant }) => {
    const parentVariant = selectedBook?.article_variants?.find(pv => pv.id === variant.b_usr_article_variant_id);
    return parentVariant && parentVariant.is_mandatory;
  })
  .reduce((acc, { key, variant }) => {
    acc[key] = variant;  // Add the filtered variants back into an object using the original key
    return acc;
  }, {});

  const selectedOtherVariants = Object.keys(selectedMandatoryVariants)?.filter(variantId => 
    parseInt(variantId) !== variant.id
  );

  if (selectedOtherVariants.length === 0) {
    // No other variants are selected, sum all matching combinations' quantities
    availableQuantity = matchingCombinations.reduce((totalQty, comb) => {
      return totalQty + (comb.quantity > 0 ? comb.quantity : 0);
    }, 0);
  } else {
    // Some other variant items are selected, so filter combinations that match those
    matchingCombinations.forEach(comb => {
      // Check if all selected other variants match the combination items
      const isValidCombination = selectedOtherVariants?.every(variantId => {
        const selectedVariantItem = selectedVariants[variantId];

        // Find the corresponding combination item for the selected other variant
        const combItem = comb.combination_variant_items.find(item => item.variant_item.b_usr_article_variant_id == variantId);

        // Check if the combination item exists and matches the selected variant item
        return combItem && selectedVariantItem.id === combItem.b_usr_article_variant_item_id;
      });

      // If it's a valid combination and has quantity, add it to availableQuantity
      if (isValidCombination && comb.quantity > 0) {
        availableQuantity += comb.quantity;
      }
    });
  }
}
  // Determine if this item should be disabled based on available quantity
  const isVariantDisabled = availableQuantity <= 0;


          return (
            <div
              key={item.id}
              className={classes.variant_item}
              style={{
                padding: item?.image ? '0' : '1.7em 1em',
                border: selectedVariants[variant.id]?.id === item.id
                  ? "2px solid var(--secondary-color)"
                  : "2px solid #D9D9D9",
                opacity: isVariantDisabled ? 0.6 : 1,
              }}
              onClick={(e) => {
                e.preventDefault();
                handleVariantSelect(variant.id, item);
              }}
            >
              {item?.image ? (
                <img
                  src={item.image}
                  alt=""
                  style={{
                    width: '4.5em',
                    height: '4.5em',
                    margin: '0',
                    padding: "0",
                    display: 'block'
                  }}
                />
              ) : (
                <p style={{ fontSize:'calc(.6rem + .3vw)', margin: '0' }}>
                  {item.value} 
                  {/* <span style={{color:"red"}}>{variant?.is_mandatory && "”"}</span>  */}
                </p>
              )}
              {isVariantDisabled && (
                <div className={classes.diagonaloverlay}>
                  <img src={NoVariants} alt="" style={{width:"100%",height:"100%"}}/>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
})}

          {selectedBook?.variant_product?.variant_product_combine_fields?.map((variant) => {
            return (
              <div key={variant.id}>
                <p
                  style={{
                    fontWeight: "600",
                    fontSize: "calc(.8rem + .3vw)",
                    marginBottom: "0.5em",
                    color: "var(--accent-color)",
                  }}
                >
                  <span style={{ color: "var(--secondary-color)" }}>{variant?.field_name}</span>{" "}
                  <span style={{ color: "red" }}>*</span>
                </p>

                <div className={classes.selectVariant}>
                  {variant.values?.map((item) => {
                    const nextSelections = {
                      ...selectedVariantProductValues,
                      [variant.id]: item,
                    };

                    const compatibleRowsForItem = getCompatibleVariantProducts(nextSelections);
                    const availableQuantity = compatibleRowsForItem.reduce(
                      (sum, variantRow) => sum + Math.max(0, getVariantProductQty(variantRow)),
                      0
                    );
                    const isVariantDisabled = availableQuantity <= 0;

                    return (
                      <div
                        key={item.id}
                        className={classes.variant_item}
                        style={{
                          position: "relative",
                          padding: item?.image ? "0" : "1em 0.8em",
                          minWidth: "2.5em",
                          textAlign: "center",
                          cursor: isVariantDisabled ? "not-allowed" : "pointer",
                          border:
                            selectedVariantProductValues[variant.id]?.id === item.id
                              ? "2px solid var(--secondary-color)"
                              : "2px solid #D9D9D9",
                          opacity: isVariantDisabled ? 0.6 : 1,
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          handleVariantProductSelect(variant.id, item);
                        }}
                      >
                        {item?.image ? (
                          <img
                            src={item.image}
                            alt=""
                            style={{
                              width: "4.5em",
                              height: "4.5em",
                              margin: "0",
                              padding: "0",
                              display: "block",
                            }}
                          />
                        ) : (
                          <p style={{ fontSize: "calc(.6rem + .3vw)", margin: "0" }}>
                            {item.display_text || item.value || item.nom || item.nom_fr}
                          </p>
                        )}
                        {isVariantDisabled && (
                          <div className={classes.diagonaloverlay}>
                            <img src={NoVariants} alt="" style={{ width: "100%", height: "100%" }} />
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
              <p style={{margin:'auto 0'}}>
                {" "}
                <span
                  style={{
                    color: "var(--accent-color)",
                    fontSize: "calc(1.8rem + 0.5vw)",
                    lineHeight: "100%",
                    paddingRight: "0.5em",
                    fontWeight: "700",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  {currency === "eur"
  ? `${
      selectedBook?.discount > 0
        ? (selectedBook?._prix_public_ttc - selectedBook?._prix_public_ttc * (selectedBook?.discount / 100)).toFixed(2)
        : (Number(selectedBook?._prix_public_ttc)).toFixed(2)
    }€`
  : `${selectedBook?.discount > 0
        ? (
            (selectedBook?._prix_public_ttc - selectedBook?._prix_public_ttc * (selectedBook?.discount / 100)) * authCtx.currencyRate
          ).toFixed(2)
        : (selectedBook?._prix_public_ttc * authCtx.currencyRate).toFixed(2)
    }$`}
                </span>{" "}
              </p>
              {selectedBook?.discount > 0 && <p
                style={{
                  color: "var(--primary-color)",
                  textDecoration: "line-through",
                  fontSize: "calc(1.8rem + 0.3vw)",
                  margin:"0"
                }}
              >
                {currency === "eur"
                  ? ` ${Number(selectedBook?._prix_public_ttc).toFixed(2)}€`
                  : ` ${(
                      selectedBook?._prix_public_ttc * authCtx.currencyRate
                    ).toFixed(2)}$`}
              </p>}
            {selectedBook?.discount > 0 && (
              <div className={classes.discountBtn}>
                -{selectedBook?.discount}%
              </div>
            )}
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div className={classes.favoriteBtnMob}>
              <div
                className={classes.favoriteBtnMobile}
                onClick={FavoriteClick}
              >
                <span>{language === "eng" ? "Favorite" : "Favourite"}</span>
                {favorite ? (
                  <FavoriteIcon
                    style={{
                      color: "var(--primary-color)",
                      height: "0.7em",
                      marginTop: "0.15em",
                    }}
                  />
                ) : (
                  <FavoriteBorderIcon
                    style={{
                      color: "var(--primary-color)",
                      height: "0.7em",
                      marginTop: "0.15em",
                    }}
                  />
                )}
              </div>
            </div>
            <TextField
              select
              type="number"
              value={count}
              onChange={handleCountChange}
              variant="outlined"
              defaultValue={1}
              InputProps={{
                inputProps: { min: 1 },
                style: {
                  margin: "0",
                  height: "2.4em",
                  backgroundColor: "#fff",
                },
              }}
              className={classes.selectMob}
            >
              {numberOptions.map((number) => (
                <MenuItem key={number} value={number}>
                  {number}
                </MenuItem>
              ))}
            </TextField>
            {selectedBook?._qte_a_terme_calcule > 0 ? <button   disabled={authCtx.isLoading}
              onClick={(event) => {
                event.stopPropagation();
                AddtoBag(selectedBook)
              }}
              className={classes.button}
              style={{ fontWeight: "400" ,cursor:authCtx.isLoading ? "wait" : 'pointer'}}
            > 
              <ShoppingCartOutlinedIcon style={{ height: "0.7em" }} />
              {language === "eng" ? "Add to Cart" : " Ajouter au panier"}
            </button>: <div/>}
          </div>
        </div>
        <div className={classes.mobViewTab}>
          <ViewTab />
        </div>
        <div className={classes.ratingMob}>
              <span>
              <Rating
                size="small"
                name="book-rate"
                readOnly
                value={averageRating}
                precision={0.5}
                //   value={selectedBook?.rate}
                style={{
                  color: "var(--primary-color)",
                  width: "fit-content",
                  marginLeft: "auto",
                  textAlign: "left",
                  marginTop: "0.5em",
                }}
              />

              </span>
              <p style={{ color: "var(--primary-color)" }}>
                {selectedBook?.average_rate}/5 ({selectedBook?.bookreview?.length} {language === 'eng' ? "reviews" : "revues"})
              </p>
            </div>
        <div className={classes.payment}>
          <p className={classes.partager}>
            {language === "eng" ? "Share" : "Partager"}:
            <div style={{ cursor: "pointer", margin: "auto 0 auto 4%" }}
                onClick={() =>
                  window.open(
                    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`,
                    "_blank"
                  )
                }>
              <FaFacebookF
                style={{
                  position: "relative",
                  margin: "auto 0",
                }}
              />
            </div>
            <div  style={{ cursor: "pointer", margin: "auto 0 auto 4%" }}
    onClick={() =>
      window.open(
        `https://twitter.com/intent/tweet?url=${encodeURIComponent(
          window.location.href
        )}`,
        "_blank"
      )
    }>
              <FaXTwitter
                style={{
                  position: "relative",
                  margin: "auto 0",
                }}
              />
            </div>
            <div  style={{ cursor: "pointer", margin: "auto 0 auto 4%" }}
    onClick={() =>
      window.open(
        `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          window.location.href
        )}`,
        "_blank"
      )
    }>
              <FaLinkedinIn
                style={{
                  position: "relative",
                  margin: "auto 0",
                }}
              />
            </div>
          </p>
          <div className={classes.paymentsMethods}>
            <img src={visa} alt="payment" className={classes.paymentImg} />
            <img
              src={mastercard}
              alt="payment"
              className={classes.paymentImg}
            />
            <img src={paypal} alt="payment" className={classes.paymentImg} />
          </div>
        </div>
      </div>
      <div className={classes.paymentsMethodsMob}>
        <img src={visa} alt="payment" className={classes.paymentImg} />
        <img src={mastercard} alt="payment" className={classes.paymentImg} />
        <img src={paypal} alt="payment" className={classes.paymentImg} />
      </div>
    </>
  );
};

export default Details;
